import React from 'react';
import SearchOnlyPanel from './components/SearchOnlyPanel';

interface SearchModuleProps {
  baseUrl: string;
  darkMode: boolean;
  language: string;
  contextData?: any;
  callBackEvent: (eventType: string, eventData: any) => void;
}

export const SearchOnlyModule = ({
  baseUrl,
  darkMode,
  language,
  contextData,
  callBackEvent
}: SearchModuleProps) => {
  return (
    <SearchOnlyPanel
      baseUrl={baseUrl}
      darkMode={darkMode}
      language={language}
      contextData={contextData}
      callBackEvent={callBackEvent}
    />
  );
}; 